// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2uX-0","topBottomGutter":"Layout_topBottomGutter__1lfUc"};